/* VINTAGIO France — interactions du thème */
(function(){
  function closeAllDrops(except){
    document.querySelectorAll('[data-vg-drop-btn][aria-expanded="true"]').forEach(function(b){
      if(b===except)return;
      b.setAttribute('aria-expanded','false');
      var d=document.getElementById(b.getAttribute('aria-controls')); if(d)d.hidden=true;
    });
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-vg-drop-btn]');
    if(b){
      var d=document.getElementById(b.getAttribute('aria-controls'));
      var open=b.getAttribute('aria-expanded')==='true';
      closeAllDrops(b);
      b.setAttribute('aria-expanded',String(!open)); if(d)d.hidden=open;
      return;
    }
    var t=e.target.closest('[data-vg-toggle]');
    if(t){
      var el=document.getElementById(t.getAttribute('data-vg-toggle'));
      if(el){
        var willOpen=el.hidden;
        document.querySelectorAll('[data-vg-group="'+(t.getAttribute('data-vg-group')||'')+'"]').forEach(function(o){ if(o!==t){ var x=document.getElementById(o.getAttribute('data-vg-toggle')); if(x&&x!==el){x.hidden=true;o.setAttribute('aria-expanded','false');} } });
        el.hidden=!willOpen; t.setAttribute('aria-expanded',String(willOpen));
        if(willOpen){ var f=el.querySelector('input[type=search],input[type=text]'); if(f)setTimeout(function(){f.focus();},30); }
        if(el.classList.contains('vg-drawer')) document.documentElement.style.overflow=willOpen?'hidden':'';
      }
      return;
    }
    if(e.target.closest('[data-vg-close]')){
      var dr=e.target.closest('.vg-drawer'); if(dr){dr.hidden=true;document.documentElement.style.overflow='';}
      return;
    }
    if(!e.target.closest('.vg-header')) closeAllDrops();
  });
  document.addEventListener('keydown',function(e){
    if(e.key!=='Escape')return;
    closeAllDrops();
    document.querySelectorAll('.vg-drawer:not([hidden])').forEach(function(d){d.hidden=true;});
    document.documentElement.style.overflow='';
  });

  /* Filtres : un changement relance la recherche */
  document.querySelectorAll('form[data-vg-filters]').forEach(function(f){
    f.addEventListener('change',function(e){ if(e.target.matches('input[type=checkbox]')) f.requestSubmit ? f.requestSubmit() : f.submit(); });
    f.addEventListener('submit',function(){
      f.querySelectorAll('input').forEach(function(i){ if((i.type==='number'||i.type==='text')&&!i.value) i.disabled=true; });
    });
  });

  /* Panier : quantité */
  document.querySelectorAll('[data-vg-qty]').forEach(function(w){
    var inp=w.querySelector('input');
    w.querySelectorAll('button').forEach(function(b){
      b.addEventListener('click',function(){
        var v=Math.max(0,(parseInt(inp.value,10)||0)+(b.dataset.d==='+'?1:-1)); inp.value=v;
        inp.form && (inp.form.requestSubmit ? inp.form.requestSubmit() : inp.form.submit());
      });
    });
  });
})();
